import { render } from "./StockCell.vue?vue&type=template&id=2bb1c2e9"
import script from "./StockCell.vue?vue&type=script&lang=js"
export * from "./StockCell.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__